<div id="ey-navbar-container">
  <div id="ey-app-home" class="ey-app-home">
    <div class="ey-max-container">

      <img class="ey-bg-logo" src="assets/images/ey-bg-log-3.png" />
      <button pButton type="submit" (click)="logout()" class="d-flex ms-auto border-0 ey-btn-trans " title="Logout">
        <i class="pi pi-power-off lg-btn"></i>
      </button>
      <div id="sign-in-container" class="sign-in-container">
        
        <div class="admin-heading" role="heading" aria-level="1"></div>
        <div class="sub-text-container">
          <div style="color: red; text-align: end;    color: red;
          font-size: 20px;
          margin-right: 150px ">
            {{errorMsg}}
          </div>

          <div class="sub-text">
          </div>
        </div>
        <div  id="login-btn">
          <div>
         <select id="ctrList"  class="form-select me-2"    (change)="country1($event);showHide($event.target.value); "   id="selectedCountryCode">
              <option value="default" selected id="choose"  class="alert alert-danger" role="alert" aria-errormessage="Select a Country">
                Select a Country</option>
              <option value="GBL" id="Global" >Global</option>
              <option value="IN"  id="India" >India</option>
              <option value="JP"  id="Japan" >Japan</option>
              <option value="PL"  id="Poland" >Poland</option>
              <option value="KSA"  id="KSA" >Kingdom of Saudi Arabia</option>
              <option value="FR"  id="France" >France</option>
              <option value="RO"  id="Romania" >Romania</option>
              <option value="AU"  id="Australia" >Australia</option>
              <option value="IT" id="Italy">Italy</option>
              <option value="MY" id="Malaysia">Malaysia</option>
              <option value="MIS" id="clientSummary">Client Summary</option>
             </select>
          </div>
          <div>
            <button pButton type="submit" class="ey-button mt-0 ey-sign-btn1" (click)='redirectDashboard()' >
              Continue
            </button>
        
        </div>

        </div>

      </div>

    </div>

  </div>